import React from 'react';
import { Key, Clock } from 'lucide-react';

const ApiKeyManagement: React.FC = () => {
  return (
    <div className="relative min-h-screen">
      {/* Blurred background content */}
      <div className="absolute inset-0 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900 dark:text-white">API</h1>
              <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                Manage your API keys for integrating with RoomSync
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <button
                className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Create New Key
              </button>
            </div>
          </div>

          {/* Placeholder content */}
          <div className="grid gap-6 md:grid-cols-2">
            <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg overflow-hidden">
              <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
                <div className="flex justify-between items-start">
                  <div>
                    <h3 className="text-lg font-medium text-gray-900 dark:text-white">Production Key</h3>
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                      Created March 20, 2024
                    </p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-200">
                      Active
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Coming Soon Overlay */}
      <div className="absolute inset-0 flex items-center justify-center bg-gray-900/50 dark:bg-slate-900/50 backdrop-blur-sm z-50">
        <div className="bg-white/90 dark:bg-slate-800/90 backdrop-blur-xl p-8 rounded-2xl shadow-2xl border border-slate-200/50 dark:border-slate-700/50 max-w-md w-full mx-4 text-center">
          <div className="w-16 h-16 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg">
            <Key className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">Coming Soon!</h2>
          <p className="text-slate-600 dark:text-slate-300 mb-6">
            We're working on bringing you a powerful API key management system. Stay tuned for updates!
          </p>
          <div className="flex items-center justify-center gap-2 text-sm text-slate-500 dark:text-slate-400">
            <Clock className="w-4 h-4" />
            <span>Feature in development</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiKeyManagement;